import { FC } from 'react';

import { LegalClientVersionEntity } from 'api/types/entity';
import { NavigationBreadcrumbsTitles } from 'components';
import { LayoutWithNavigationBreadcrumbs } from 'components/LayoutWithNavigationBreadcrumbs';
import { Form } from 'libs/form/Form';
import { VersionView } from 'modules/client/common/views';

import {
  LegalClientBranchSections,
  LegalClientBranchSectionsProps,
} from '../components';
import { LegalClientBranchFormType } from '../forms/legalClientBranchForm';

export interface LegalClientBranchVersionViewProps
  extends LegalClientBranchSectionsProps {
  breadcrumbsTitles: NavigationBreadcrumbsTitles;
  versions: LegalClientVersionEntity[];
  initialValues?: LegalClientBranchFormType;
  fullName: string;
  versionId: string;
  snapshotLoading?: boolean;
  error?: string;
  onChangeVersion: (version: LegalClientVersionEntity) => void;
  onCloseVersionHistory: () => void;
}

export const LegalClientBranchVersionView: FC<
  LegalClientBranchVersionViewProps
> = ({
  breadcrumbsTitles,
  versions,
  fullName,
  initialValues,
  snapshotLoading,
  versionId,
  error,
  onCloseVersionHistory,
  onChangeVersion,
  ...sectionsProps
}) => (
  <LayoutWithNavigationBreadcrumbs titles={breadcrumbsTitles}>
    <VersionView
      content={
        initialValues && (
          <Form
            initialReadOnly
            initialShowCopyButton
            initialValues={initialValues}
            onSubmit={() => {}}
          >
            <LegalClientBranchSections {...sectionsProps} />
          </Form>
        )
      }
      error={error}
      loading={snapshotLoading}
      name={fullName}
      versionId={versionId}
      versions={versions}
      onChangeVersion={onChangeVersion}
      onCloseVersionHistory={onCloseVersionHistory}
    />
  </LayoutWithNavigationBreadcrumbs>
);
